import { render, staticRenderFns } from "./Matching-problem.vue?vue&type=template&id=4289e1f1"
import script from "./Matching-problem.vue?vue&type=script&lang=js"
export * from "./Matching-problem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports